import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TermsCacheEntry } from '../auth/deviceTerms';

export const DEVICE_TERMS_STORAGE_KEY = 'persist:deviceTerms';
export type DeviceTermsState = { byAccount: Record<string, TermsCacheEntry> };
const slice = createSlice({
  name: 'deviceTerms',
  initialState: { byAccount: {} } as DeviceTermsState,
  reducers: {
    recordDeviceAcceptance: (state, { payload }: PayloadAction<{ key: string; receipt: TermsCacheEntry }>) => {
      state.byAccount[payload.key] = payload.receipt;
    },
  },
});
export const { recordDeviceAcceptance } = slice.actions;
export default slice.reducer;

/** Keep only non-secret device receipts across logout; all session data is still removed. */
export function clearStorageKeepingDeviceTerms() {
  const receipt = localStorage.getItem(DEVICE_TERMS_STORAGE_KEY);
  localStorage.clear();
  if (receipt) localStorage.setItem(DEVICE_TERMS_STORAGE_KEY, receipt);
  sessionStorage.clear();
}
